<template>
    <div>
        <Card>
            <div class="search-con search-con-top">
                <Form :model="form" :label-width="80" inline>
                    <FormItem label="机构名称">
                        <Input v-model="form.map.orgName"></Input>
                    </FormItem>
                    <FormItem label="机构联系人">
                        <Input v-model="form.map.orgContacts"></Input>
                    </FormItem>
                </Form>
                <div  class="toolbar">
                    <Button type="primary" icon="md-add" @click="handleCreate">新增</Button>
                    <Button type="primary" icon="md-trash" @click="handleDelete">删除</Button>
                   <Button @click="handleSearch" icon="md-search" class="search-btn" type="primary">搜索 </Button>
                </div>
            </div>
            <Tables ref="tables" v-model="tableData" :columns="columns" @on-search="handleSearch"
                    @on-update="handleUpdate" @on-detail="handleDetail" @on-selection-change="selectionChange"/>
        </Card>
        <organsinfo ref="finacialorgansinfoInfoRef"  @handle-search="handleSearch"></organsinfo>
    </div>
</template>

<script>
import organsinfo from './organs-info'
import { getIds } from '@/libs/util'

export default {
  name: 'organs-list',
  components: {
    organsinfo
  },
  data () {
    return {
      currentChoose: '',
      columns: [
        {
          title: ' ',
          key: 'id',
          width: 60,
          align: 'center',
          render: (h, params) => {
            let id = params.row.id
            let flag = false
            if (this.currentChoose === id) {
              flag = true
            }
            let self = this
            return h('div', [
              h('checkbox', {
                props: {
                  value: flag
                },
                on: {
                  'on-change': () => {
                    self.selectedData = []
                    self.currentChoose = id
                    self.selectedData.push(params.row)
                  }
                }
              })
            ])
          }
        },
        { title: '机构名称', key: 'orgName' },
        { title: '经营范围', key: 'orgBusinessScop' },
        { title: '地址', key: 'orgAddress' },
        { title: '联系人', key: 'orgContacts' },
        { title: '联系电话', key: 'orgPhone' },
        {
          title: '操作',
          key: 'handle',
          minWidth: 220,
          options: ['update', 'detail']
        }
      ],
      tableData: {
        rows: [],
        total: 0
      },
      form: {
        map: {}
      },
      selectedData: [],
      orgStatusOptions: {},
      profitSharingOptions: {},
      paymentModeOptions: {},
      infoIsShow: false
    }
  },
  methods: {
    handleUpdate (param) {
      this.$refs.finacialorgansinfoInfoRef.openModel('update', param.row)
    },
    handleDetail (param) {
      this.$refs.finacialorgansinfoInfoRef.openModel('detail', param.row)
    },
    handleCreate () {
      this.$refs.finacialorgansinfoInfoRef.openModel('create')
    },
    handleDelete () {
      this.G('admin/organsbaseinfo/delete/' + getIds(this.selectedData)[0]).then(data => {
        this.$Message.success(data)
        this.handleSearch()
      })
    },
    selectionChange (selection) {
      this.selectedData = selection
    },
    handleSearch (page, pageSize) {
      this.form.map.orgType = '0'
      if (isNaN(page)) {
        page = 1
      }
      var param = {
        page: page,
        pageSize: pageSize,
        model: this.form,
        map: this.form.map
      }
      this.P('admin/finacialorgansinfo/listOrgans', param).then(data => {
        this.tableData = data
      })
    }
  },
  mounted () {
    this.handleSearch()
  }
}
</script>
